import { render, staticRenderFns } from "./waitTransport copy.vue?vue&type=template&id=28e09685&scoped=true"
import script from "./waitTransport copy.vue?vue&type=script&lang=js"
export * from "./waitTransport copy.vue?vue&type=script&lang=js"
import style0 from "./waitTransport copy.vue?vue&type=style&index=0&id=28e09685&prod&scoped=true&lang=scss"
import style1 from "./waitTransport copy.vue?vue&type=style&index=1&id=28e09685&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e09685",
  null
  
)

export default component.exports